import _styled from "../../_snowpack/pkg/styled-components.js";
import React from '../../_snowpack/pkg/react.js';
import PropTypes from '../../_snowpack/pkg/prop-types.js';
import styled from '../../_snowpack/pkg/styled-components.js';
import is from '../../_snowpack/pkg/styled-is.js';
const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const CalendarWrapper = styled.div.withConfig({
  displayName: "dummy-calendar__CalendarWrapper",
  componentId: "ton322-0"
})(["display:flex;flex-direction:column;color:#757575;font-size:11px;padding:10px 0;align-items:center;cursor:default;"]);

var _StyledCalendarWrapper = styled(CalendarWrapper).withConfig({
  displayName: "dummy-calendar___StyledCalendarWrapper",
  componentId: "ton322-1"
})(["", ""], p => p._css);

const CalendarHeader = styled.strong.withConfig({
  displayName: "dummy-calendar__CalendarHeader",
  componentId: "ton322-2"
})(["font-size:14px;color:#484848;margin-bottom:3px;"]);
const Calendar = styled.div.withConfig({
  displayName: "dummy-calendar__Calendar",
  componentId: "ton322-3"
})(["display:grid;grid-template-columns:repeat(7,1fr);grid-gap:2px 1px;.calendar-days{grid-column:span 7;display:grid;grid-template-columns:repeat(7,1fr);grid-gap:1px;}span{text-align:center;padding:2px;}"]);
const CalendarDay = styled.span.withConfig({
  displayName: "dummy-calendar__CalendarDay",
  componentId: "ton322-4"
})(["color:#000;border:1px solid rgb(228,231,231);background-color:#fff;", ";", ";"], is('selected')`
    background-color: #8fdecb !important;
    color: #fff !important;
  `, is('startPosition')`
    grid-column-start: ${p => p.startPosition};
  `);

function DummyCalendar({
  styles,
  nextMonth
}) {
  const date = new Date();
  const year = nextMonth ? new Date(date.getFullYear(), date.getMonth() + 1, 1).getFullYear() : date.getFullYear();
  const month = nextMonth ? new Date(date.getFullYear(), date.getMonth() + 1, 1).getMonth() : date.getMonth();
  const monthName = monthNames[month];
  const numberOfDays = new Date(year, month + 1, 0).getDate();
  const daysArray = Array.apply(null, Array(numberOfDays));
  const today = date.getDate();
  const positionFirsDay = new Date(year, month, 1).getDay();
  return /*#__PURE__*/React.createElement(_StyledCalendarWrapper, {
    _css: styles
  }, /*#__PURE__*/React.createElement(CalendarHeader, null, `${monthName} ${year}`), /*#__PURE__*/React.createElement(Calendar, null, ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'].map(d => /*#__PURE__*/React.createElement("span", {
    key: d
  }, d)), /*#__PURE__*/React.createElement("div", {
    className: "calendar-days"
  }, [daysArray.map((_, index) => {
    const day = index + 1;
    return /*#__PURE__*/React.createElement(CalendarDay, {
      key: `dummy-calendar-day-${day}`,
      selected: today === day,
      startPosition: index === 0 && positionFirsDay
    }, day);
  })])));
}

DummyCalendar.propTypes = {
  nextMonth: PropTypes.bool,
  styles: PropTypes.string
};
export default DummyCalendar;